<script lang="ts" setup>
import { useTheme } from '@/modules/App/useTheme'

withDefaults(
  defineProps<{
    color: 'default' | 'subtle' | 'inverted'
    width?: 1 | 2
    direction?: 'horizontal' | 'vertical'
  }>(),
  { direction: 'horizontal', width: 1 },
)

const { actualTheme } = useTheme()
</script>

<template>
  <div
    role="separator"
    :aria-orientation="direction"
    class="flex items-center justify-center gap-2"
    :class="[direction === 'horizontal' ? 'w-full' : 'h-full']"
  >
    <div
      class="rounded-corner-1"
      :class="[
        color === 'default' && 'bg-background-border-default',
        color === 'subtle' && 'bg-background-border-subtle',
        color === 'inverted' && actualTheme === 'light' && 'bg-[#FFF] opacity-10',
        color === 'inverted' && actualTheme === 'dark' && 'bg-[#000] opacity-10',
        direction === 'horizontal' && width === 1 && 'h-px w-full',
        direction === 'horizontal' && width === 2 && 'h-[2px] w-full',
        direction === 'vertical' && width === 1 && 'h-full w-px',
        direction === 'vertical' && width === 2 && 'h-full w-[2px]',
      ]"
    />
    <template v-if="$slots.default">
      <div class="shrink-0">
        <slot />
      </div>
      <div
        class="rounded-corner-1"
        :class="[
          color === 'default' && 'bg-background-border-default',
          color === 'subtle' && 'bg-background-border-subtle',
          direction === 'horizontal' && width === 1 && 'h-px w-full',
          direction === 'horizontal' && width === 2 && 'h-[2px] w-full',
          direction === 'vertical' && width === 1 && 'h-full w-px',
          direction === 'vertical' && width === 2 && 'h-full w-[2px]',
        ]"
      />
    </template>
  </div>
</template>
